import { i18n } from '@/i18n';
import { CouponItemCfg } from '@/types/merchant-info';
import dayjs from 'dayjs';
import { CouponInfoItem } from '@tencent/wphk-act-base-cgi';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { CouponState } from '@tencent/wphk-act-base-components';
import { CouponItem } from '@/views/home/e-cash-coupon/types';

/**
 * 获取可用的活动加密串列表
 */
export function getActListId(couponList: CouponItemCfg[]) {
  const now = getServerTime();
  const actListId: string[] = couponList.
    filter(item => now >= dayjs(item.startTime).toDate() && now < dayjs(item.endTime).toDate())
    .map(item => item.actIdEn);
  return actListId;
}

/**
 * 获取连锁券使用提示
 */
function getTipsText(item: CouponInfoItem, couponType: string|undefined) {
  let canReceiveNum = 0;
  if (couponType === 'chain' && (canReceiveNum = item.totalNum - item.recivedNum) > 1) {
    return i18n('共多少張券，使用後領取下一張', {
      canReceiveNum,
    });
  }
  return '';
}

/**
 * 格式化优惠券数据
 */
export function formatCoupon(srcCouponList: CouponInfoItem[], couponType?: string) {
  const couponList: CouponItem[] = srcCouponList.map(((item) => {
    const couponDesc = i18n('消費HK多少可使用', {
      requiredNum: item.requiredNum,
    });
    return {
      originalCouponInfo: {
        couponName: item.couponName,
        couponDesc,
        couponState: `${item.state}` as CouponState,
        userCouponid: item.userCouponid,
        discount: item.discount,
        isShowButton: true,
        isChainCoupon: couponType === 'chain',
      },
      extraParams: {
        prizeName: item.couponName,
        prizeDesc: couponDesc,
        tipsText: getTipsText(item, couponType),
      },
      couponItem: item,
    };
  }));
  return couponList;
}
